import { useUserInfo } from "@/api/user";

/**
 * The subscription the confirm-setup rules read. `/me`, not getSubscription:
 * getSubscription 404s for new orgs and can still be loading while `/me`
 * already reports `trialing`, and getting this wrong flips `trial_end_now` —
 * charging a trialing customer early, or failing to convert them.
 */
export function useExistingSubscription(): {
  hasExistingSubscription: boolean;
  existingSubscriptionStatus: string | undefined;
  isLoading: boolean;
} {
  const { data: userInfo, isLoading } = useUserInfo();
  const existing = userInfo?.subscription;

  return {
    hasExistingSubscription: Boolean(existing?.id),
    existingSubscriptionStatus: existing?.status,
    isLoading,
  };
}
